export const EConfigEnum = {
	API_DOMAIN: "API_DOMAIN",
	CUSTOM_API_DOMAIN: "CUSTOM_API_DOMAIN",
	NOT_FOUND_REDIRECT_LINK: "NOT_FOUND_REDIRECT_LINK",
	ITEMS_PER_PAGE: "ITEMS_PER_PAGE",
};
